import React, { useMemo } from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableColLabelValue } from '../../../../../components/pdf/TableHelpers'
import View from '../../../../../components/pdf/View'
import Separator from '../../../../../components/pdf/Separator'
import { getReplyValueFieldOrDefault, findReplyByQuestionName, getDate } from '../../_helpers/pdfHelpers'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { calculateAttendanceTime } from '../../../../serviceOrders/resumeV2/general/_data/counters'

const ClientData = () => {
  const serviceOrder = useServiceOrder()
  const endDate = getDate(serviceOrder.endDate)
  const name = getReplyValueFieldOrDefault(findReplyByQuestionName(serviceOrder.replies, 'Empresa'), 'value', '**N/A**')
  const auditor = getReplyValueFieldOrDefault(
    findReplyByQuestionName(serviceOrder.replies, 'Auditor'),
    'value',
    '**N/A**'
  )

  const attendanceTime = useMemo(() => {
    const events = serviceOrder.events
    const attendanceTime = calculateAttendanceTime(events)
    return attendanceTime
  }, [serviceOrder])

  return (
    <View>
      <Table width="100%" style={{ border: '' }}>
        <TableRow color={'transparent'}>
          <TableColLabelValue colSpan={2} label={'Empresa'} value={name} style={{ border: '' }} />
        </TableRow>
        <TableRow color={'transparent'}>
          <TableColLabelValue colSpan={2} label={'Auditor'} value={auditor} style={{ border: '' }} />
        </TableRow>
        <TableRow color={'transparent'}>
          <TableColLabelValue colSpan={2} label={'Data'} value={endDate} style={{ border: '' }} />
        </TableRow>
        <TableRow color={'transparent'}>
          <TableColLabelValue colSpan={2} label={'Tempo de Execução'} value={attendanceTime} style={{ border: '' }} />
        </TableRow>
        <TableRow color={'transparent'}>
          <TableColLabelValue
            colSpan={2}
            label={'Checklist'}
            value={serviceOrder.checklist.name}
            style={{ border: '' }}
          />
        </TableRow>
      </Table>
      <Separator weight={4} />
    </View>
  )
}

export default ClientData
